/*
* Module with channel (requests, commands, 'subscriptions' to event)
* Initialize acts as 'start'
* Could store on the Marionette namespace -- 'a plugin'
* */


var Marionette = require('marionette'),
	Backbone = require('backbone'),
    _ = require('underscore');

require('backbone.radio');


var slice = Array.prototype.slice;
var BR = Backbone.Radio; // Great increase in performance


var SubApp = Marionette.Object.extend({
    constructor: function( options, id ) { /* Name must always be unique, even if not an instance */

        var options = options || {},
            channelName =       _.result(this, 'channelName') || options.channelName || 'channel',
            requests =          _.result(this, 'requests') || options.requests, // what to do if none ... ?
            commands =          _.result(this, 'commands') || options.commands,
            subscriptions =     _.result(this, 'subscriptions') || options.subscriptions, /* note: these are the 'outer' */
            aInitParams =       options.aInitParams ? options.aInitParams : arguments; // workaround if called from or-constructor and init param different than those expected here

        this.id = id;
        this.channelName = channelName + ':' + id;
        this.subApps = {};

        /*
        * This would be INNER -- subscriptions / publishers; NOT NECESSARY FOR OUTER B/C NEED TO PASS IN VIEW INSTANCE ANYWAY ( could fwd )
        * Note: ability to pass in existing channel
        * */
        var ch = this.channel = ( options.channel ? options.channel : new Backbone.Radio.channel(this.channelName) );

        /* Wiring */
        requests && ch.reply(requests, this);
        commands && ch.comply(commands, this);
        Marionette.bindEntityEvents(this, ch, subscriptions);

        /*
        * This just calls init on the subject, so *** init acts like 'start' ***
        * Do on the instance, not the prototype
        * */
        Marionette.Object.prototype.constructor.apply( this, aInitParams );

    },

    /* name same as this subApp if subapp or param id if provided */
    addSubApp: function(name, options, id) {

        var subAppOptions = _.chain(options).omit('subAppClass').extend({
                channelName: name /* ignored if not subapp */
            }).value(),
            isSubApp = options.subAppClass.prototype instanceof SubApp,
            id = id ? id : this.id, //
            saName = name + ':' + id,
            subApp = new options.subAppClass(subAppOptions, id); //(latter for consistent channel name; ignored for non subapp types)

        //TODO: disallow 2 non sub-app instances with same id

        !isSubApp && _.extend( subApp, {subAppName: saName} ); //for latter id in get w/abstraction

        this.subApps[saName] = subApp; //(name no longer has id for lookup)

        // For now put on Radio as channel -- this allows to use top level api -- see 'command on'
        // Really need to call constructor to use top level radio
        if (!(subApp instanceof SubApp)) {
            Backbone.Radio._channels[saName] = subApp;
        }
        return subApp;

    },
    /**
     * Currently  unused -- (only destroy is called).
     * TODO: doesn't appear entirely functional -- this/equivalent could be used to determine the
     * order in which subApps are destroyed instead of just the destroy method -- see DVBC-1790.
     */
    removeSubApp: function(name) {
        var sa = this.subApps[name];
        sa.destroy();
        delete sa;
    },
    getSubApp: function(name) { /* really the 'base name' */

          var sa = this.subApps[name + ':' + this.id ]; // ahh wont work ? name + ':' + this.id : name
          if (sa)
              return sa;

         var id = _.chain(this.subapps)
            .filter(function(a) { return a.saName !== undefined;})
            .find(function(a) { return a.saName.indexOf(name + ':') > -1; }).value();
   
         return this.subApps[name + ':' + id]; // TODO: cache

    },
    /*
    * Makes is so modules don't need to exist
    * TODO: what if call off same subapp ?
    * */
    command: function() {
        var ch = this.channel;
        return ch.command.apply(ch, arguments);
    },
    request: function() {
        var ch = this.channel;
         return ch.request.apply(ch, arguments);
    },
    /* trigger off the channel */
    trigger: function() {
        var ch = this.channel;
        return ch.trigger.apply(ch, arguments);
    },
    /*
    * Blind trigger but turn the targets into subApp shortcuts -- for showing intent.
    * TODO: wanted? not currently used (only Marionette.blindTriggerOn currently called): -- needs testing ...
    * */
    blindTriggerOn: function(target, name) {

        if (!target)
            return;

        var args = Array.prototype.slice.call(arguments, 1); /* includes name and any arguments passed */
        if (target instanceof Array) {
            _.each(target, function(t) {
                t && t.triggerMethod && t.triggerMethod.apply(t, args);
            });
        } else {
            target.triggerMethod && target.triggerMethod.apply(target, args);
        }
    },
    /*
    * Like Backbone.Radio top level API applied to the app --
    * a command from the app to one of its subapps forward.
    * allows for calling on subapp like event and not getting error, if the subapp doesn't exist.
    * If subAppName is array, it will call on all the subapps.
    * Good for showing which subapps it's applied so don't have to debug all the listeners -- shows the intent w/out error.
    * */
    commandOn: function(subAppName, method) {
        var args;
        if (subAppName instanceof Array) {
           args = slice.call(arguments, 1);
            _.each(subAppName, function(saName) {
                if (this._subAppExists(saName))  /* if doesn't exist, don't want added to BB radio top level API */
                    BR.command.apply(BR, [].concat(saName + ':' + this.id, args));
            }, this);
            return;
        }
        if (!this._subAppExists(subAppName)) return false;
        args = slice.call(arguments, 2);
        args.unshift(subAppName + ':' + this.id, method);
        return BR.command.apply(BR, args); //lowers performance
    },
    requestOn: function(subAppName, method) {

        if (!this._subAppExists(subAppName))
            return false;

        var args;

        if (subAppName instanceof Array) {
            args = slice.call(arguments, 1);
            _.each(subAppName, function(saName) {
                if (this._subAppExists(saName))
                    BR.request.apply(BR, [].concat(saName + ':' + this.id, args));
            }, this);
            return;
        }

        if (!this._subAppExists(subAppName))
            return false;

        args = slice.call(arguments, 2);
        args.unshift(subAppName + ':' + this.id, method);
        return BR.request.apply(BR, args); //lowers performance

    },
    _subAppExists: function(subAppName) {
        return _.contains( _.keys(this.subApps), subAppName + ':' + this.id);
    },
    destroy: function() {

        this.triggerMethod('beforeDestroy');
        this.channel.reset();
        _.invoke(this.subApps, 'destroy'); //trigger in case not a subapp with destroy

    }

    // TODO: destroy all its subapps/modules ...
});



module.exports = SubApp;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/SubApp.js
 ** module id = 98
 ** module chunks = 0
 **/